import { render } from "./PopUpExplaination.vue?vue&type=template&id=4da4b977"
import script from "./PopUpExplaination.vue?vue&type=script&lang=js"
export * from "./PopUpExplaination.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__